<template>
  <v-card
    raised
    class="post-it-card"
    :class="showPostIt ? 'post-it-card-active' : ''"
    :style="showResultsSection
      ? {right: resultsContainerWidth + 20 + 'px'}
      : {right: '230px'}"
  >
    <v-card-title class="pt-0" v-show="showPostIt">
      <v-container>
          <v-layout row v-for="(row, index) in postitNotes" :key="index" class="post-it-row-container">
            <div class="post-it-row-icon-container">
              <v-icon v-if="row.icon">{{ row.icon }}</v-icon>
              <img v-if="row.img" :src="row.img" :alt="row.imgAlt">
            </div>
            <div class="post-it-row-desc-container">
              <span v-if="row.isSpacer" class="row-spacer"></span>
              <span v-else
                    :class="row.icon || row.img ? 'post-it-row-desc post-it-row-desc-with-divider' : 'post-it-row-desc'"
                    v-html="row.desc"
              ></span>
            </div>
          </v-layout>
      </v-container>
      <i18n path="notification.postIt.additionalTips.text">
        <template v-slot:howToUseUrl>
          <a target="_blank" :href="howToUseUrl">{{ $t('notification.postIt.additionalTips.howToUseText') }}</a>
        </template>
        <template v-slot:faqUrl>
          <a target="_blank" :href="howToUseUrl">{{ $t('notification.postIt.additionalTips.faqText') }}</a>
        </template>
      </i18n>
      <v-btn flat icon @click="handleClosePostIt" class="post-it-close-btn">
        <v-icon dark>close</v-icon>
      </v-btn>
    </v-card-title>

    <v-layout justify-center v-show="!showPostIt" class="post-it-toggle-btn">
      <v-btn dark icon @click.stop="showPostIt = !showPostIt">
        <v-icon>question_mark</v-icon>
      </v-btn>
    </v-layout>

  </v-card>
</template>

<script>
import { howToUseUrl, faqUrl } from '../../utils/constants'

export default {
  name: 'PostIt',
  data () {
    let postitNotes = [
      {icon: 'ads_click', desc: this.$t('notification.postIt.enterTerm')},
      {icon: 'drag_pan', desc: this.$t('notification.postIt.createGroup')},
      {desc: this.$t('notification.postIt.defaultOp')},
      {img: '../../../static/tips-icon/operator-icon.svg', imgAlt: '', desc: this.$t('notification.postIt.changeOp')},
      {img: '../../../static/tips-icon/adj-icon.svg', imgAlt: '', desc: this.$t('notification.postIt.proximity')},
      {img: '../../../static/tips-icon/dollarSign-icon.svg', imgAlt: '', desc: this.$t('notification.postIt.truncation')},
      {isSpacer: true},
      {desc: this.$t('notification.postIt.contextMenu')},
      {desc: this.$t('notification.postIt.layout')},
      {img: '../../../static/tips-icon/cutCopyPaste-icon.svg', imgAlt: '', desc: this.$t('notification.postIt.copyPaste')},
      {img: '../../../static/tips-icon/negate-icon.svg', imgAlt: '', desc: this.$t('notification.postIt.negate')},
      {img: '../../../static/tips-icon/disable-icon.svg', imgAlt: '', desc: this.$t('notification.postIt.toggleEnable')},
      {img: '../../../static/tips-icon/addTags-icon.svg', imgAlt: '', desc: this.$t('notification.postIt.fieldTags')}
    ]
    return {
      showPostIt: false,
      postitNotes: postitNotes,
      howToUseUrl: howToUseUrl,
      faqUrl: faqUrl
    }
  },
  computed: {
    showResultsSection: { get () { return this.$store.state.appState.showResultsSection } },
    resultsContainerWidth: { get () { return this.$store.state.appState.resultsContainerWidth } }
  },
  methods: {
    handleClosePostIt () {
      this.showPostIt = false
    }
  }
}
</script>

<style lang="scss" scoped>
.post-it {
  &-card {
    position: absolute;
    bottom: 6px;
    right: 24px;
    width: 450px;
    z-index: 100;
    background-color: $bg-primary;
    border-radius: 20px;
    &-active {
      border: 3px solid $warning;
    }
  }
  &-row-container {
    display: flex;
    position: relative;
  }
  &-row {
    &-icon-container {
      width: 15%;
      margin-right: 10px;
    }
    &-desc-conatainer {
      width: 100%;
      text-align: left;
    }
    &-desc {
      padding-left: 17px;
      &-with-divider {
        margin-left: 10px;
        padding-left: 5px;
        border-left: 2px solid $grey-500;
      }
    }
  }
  &-close-btn {
    position: absolute;
    right: 0;
    bottom: 0;
    border: 1px solid $warning-200;
    & .theme--dark.btn {
      color: $warning;
    }
  }
}
.post-it-close-btn .theme--dark.btn {
  color: $warning;
}
.divider-vertical {
  transform: rotate(90deg);
  max-width: 1rem;
}
.post-it-toggle-btn {
  z-index: 1000;
  position: absolute;
  top: -50px;
  right: 0;
}
.post-it-toggle-btn .btn {
  height: 30px;
  aspect-ratio: 1;
  text-transform: none;
}
.post-it-toggle-btn .theme--dark.btn {
  color: $warning;
  background-color: $grey-400;
  padding: 5px;
  height: 40px;
  width: 40px;
  border: 3px solid $warning;
}
</style>



// WEBPACK FOOTER //
// src/components/parts/PostIt.vue